import { useState, useEffect, useCallback } from "react";
import { API, AUTH, toLocalDateStr, fmtDate, exportXLSX } from "../../adminUtils";
import ExportBar from "./ExportBar";

export default function FirstVisitsReport() {
  const today = toLocalDateStr(new Date());
  const [from, setFrom]       = useState(() => { const d = new Date(); d.setDate(1); return toLocalDateStr(d); });
  const [to, setTo]           = useState(today);
  const [data, setData]       = useState(null);
  const [loading, setLoading] = useState(false);

  const fetch_ = useCallback(async () => {
    setLoading(true);
    try {
      const res  = await fetch(`${API}/reports/first-visits?from=${from}&to=${to}`, { headers: AUTH });
      const json = await res.json();
      setData(json);
    } catch { setData(null); }
    finally   { setLoading(false); }
  }, [from, to]);

  useEffect(() => { fetch_(); }, [fetch_]);

  const doExport = () => {
    if (!data?.visitors) return;
    exportXLSX("First Visits", data.visitors.map(v => ({
      Name: v.name, Email: v.email,
      "First Visit": fmtDate(v.firstVisit),
      State: v.state ?? "—", Zip: v.zip ?? "—",
      County: v.county ?? "—",
      Local: v.isLocal ? "Yes" : "No",
      "Out of State": v.outOfState ? "Yes" : "No",
      "Payment Type": v.paymentLabel,
      "Converted to Pass": v.converted ? "Yes" : "No",
    })), `iy-sp-first-visits-${from}-${to}.xlsx`);
  };

  return (
    <div>
      <div className="adm-report-filters">
        <div className="adm-filter-group">
          <label className="adm-filter-label">From</label>
          <input type="date" className="adm-input" value={from} onChange={e => setFrom(e.target.value)} />
        </div>
        <div className="adm-filter-group">
          <label className="adm-filter-label">To</label>
          <input type="date" className="adm-input" value={to} max={today} onChange={e => setTo(e.target.value)} />
        </div>
      </div>
      {loading && <p className="adm-loading">Loading…</p>}
      {data && !loading && (
        <>
          <div className="adm-report-summary-row">
            {[
              { label: "New students",      value: data.summary.total },
              { label: "Local (Tampa Bay)", value: data.summary.local },
              { label: "Out of state",      value: data.summary.outOfState },
              { label: "Other FL",          value: data.summary.otherFL },
              { label: "Drop-in",           value: data.summary.dropIns },
              { label: "Converted",         value: data.summary.converted },
            ].map(s => (
              <div key={s.label} className="adm-summary-chip">
                <span className="adm-summary-val">{s.value}</span>
                <span className="adm-summary-lbl">{s.label}</span>
              </div>
            ))}
          </div>
          <ExportBar onXLSX={doExport} />
          {data.visitors.length === 0
            ? <p className="adm-empty">No new students in this period.</p>
            : (
              <div className="adm-table-wrap">
                <table className="adm-table">
                  <thead>
                    <tr><th>Name</th><th>First Visit</th><th>Location</th><th>Payment</th><th>Local</th><th>Converted</th></tr>
                  </thead>
                  <tbody>
                    {data.visitors.map((v, i) => (
                      <tr key={i}>
                        <td>
                          <div>{v.name}</div>
                          <div className="adm-email">{v.email}</div>
                        </td>
                        <td>{fmtDate(v.firstVisit)}</td>
                        <td>
                          {v.zip && <span>{v.zip}</span>}
                          {v.county && <span className="adm-locality-badge">{v.county}</span>}
                          {v.outOfState && <span className="adm-oos-badge">{v.state}</span>}
                        </td>
                        <td><span className="adm-type-badge">{v.paymentLabel}</span></td>
                        <td>{v.isLocal ? <span className="adm-local-yes">✓ Local</span> : <span className="adm-local-no">—</span>}</td>
                        <td>{v.converted ? <span className="adm-converted-yes">✓</span> : "—"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )
          }
        </>
      )}
    </div>
  );
}